import React from 'react';
import { Building2, Shield, MapPin, CreditCard, XCircle, Gift } from 'lucide-react';

const TrustStrip = () => {
  const features = [
    {
      icon: <XCircle className="h-4 w-4" />,
      text: 'Free Cancellation',
      highlight: true,
    },
    {
      icon: <Gift className="h-4 w-4" />,
      text: 'Free Meet & Greet',
      highlight: true,
    },
    {
      icon: <Shield className="h-4 w-4" />,
      text: 'No Hidden Fees',
    },
    {
      icon: <CreditCard className="h-4 w-4" />,
      text: 'PayPal Accepted',
    },
  ];

  return (
    <section className="bg-dark-elevated py-4 md:py-5 border-y border-border/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 md:gap-x-12">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`flex items-center gap-2 ${
                feature.highlight 
                  ? 'text-green-400 font-semibold' 
                  : 'text-foreground/70'
              }`}
            >
              <span className={feature.highlight ? 'text-green-400' : 'text-primary'}>
                {feature.icon}
              </span>
              <span className="text-sm font-medium">{feature.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustStrip;
